var app = {
	header: {
		build: "构建",
		closeButton: "关闭",
		copyrightLabel: "版权",
		helpLabel: "帮助",
		legalNoticeLabel: "法律声明",
		logoutButton: "登出",
		menuLabel: "菜单",
		module: "模块",
		noUserDataLabel: "没有用户数据",
		notificationsLabel: "通知",
		privacyPolicyLabel: "隐私政策",
		serviceAppLabel: "服务应用",
		settingsLabel: "设置",
		shopLabel: "商店",
		smartFactorySuiteLabel: "智能工厂套件",
		softwareInformation: "软件信息",
		userLabel: "个人资料",
		userProfileLinkText: "用户资料",
		version: "版本"
	}
};
var contentLoadingError = "无法加载内容";
var dashboard = {
	cancel: {
		button: "取消"
	},
	edit: {
		button: "编辑"
	},
	reset: {
		button: "重置"
	},
	save: {
		button: "保存"
	},
	share: {
		button: "分享"
	}
};
var filter = {
	clear: "重置筛选器",
	clearAll: "重置所有筛选器"
};
var locationMap = {
	locationLink: {
		label: "转到位置"
	}
};
var machineDiscontinuation = {
	linkText: "了解更多"
};
var notifications = {
	button: {
		loadMore: "加载更多"
	},
	date: {
		lastMonth: "上个月",
		lastWeek: "上周",
		older: "更早",
		thisMonth: "本月",
		thisWeek: "本周",
		today: "今天",
		yesterday: "昨天"
	},
	error: {
		general: "当前无法显示通知。请稍后再试。",
		unauthorized: "请登录以查看通知"
	},
	info: {
		activateSettings: "要接收通知，请在设置中启用它们",
		noNotification: "目前没有消息"
	},
	title: "通知"
};
var results = {
	counter: {
		label: "条结果"
	}
};
var scrollToTop = {
	label: "滚动到顶部"
};
var slider = {
	nextButton: {
		label: "下一张幻灯片"
	},
	paginationBullet: {
		label: "幻灯片"
	},
	prevButton: {
		label: "上一张幻灯片"
	}
};
var sorting = {
	ascending: "升序",
	descending: "降序"
};
var userAccount = {
	address: {
		label: "邮寄地址"
	},
	email: {
		label: "电子邮件"
	},
	language: {
		label: "语言",
		locale: "区域设置",
		select: "选择语言",
		settings: "语言设置"
	},
	loggedOut: {
		message: "您未登录"
	},
	login: {
		button: "登录"
	},
	name: {
		label: "姓名"
	},
	phone: {
		label: "电话"
	}
};
var widget = {
	filter: {
		machine: {
			filter: "过滤机器",
			label: "机器",
			option: {
				all: "所有机器"
			},
			select: "选择机器"
		},
		period: {
			label: "时期",
			option: {
				currentMonth: "本月",
				currentWeek: "本周",
				lastMonth: "上个月",
				lastWeek: "上周",
				today: "今天",
				yesterday: "昨天"
			}
		}
	}
};
var widgetRegistry = {
	allWidgets: {
		label: "我的小部件"
	},
	noDescriptionAvailable: "没有可用的描述。",
	widget: {
		SampleMyMachines: {
			title: "我的机器"
		},
		SampleMyServiceCalls: {
			title: "服务呼叫"
		},
		SampleMyTrackingList: {
			title: "跟踪列表"
		},
		SampleMyUserAccount: {
			title: "我的个人资料"
		},
		SampleOperationalStatesChart: {
			title: "运行状态"
		},
		SampleWidgetFilter: {
			title: "筛选设置"
		},
		SampleWorkloadBalanceChart: {
			title: "工作负载平衡"
		}
	}
};
var translation = {
	app: app,
	contentLoadingError: contentLoadingError,
	dashboard: dashboard,
	filter: filter,
	locationMap: locationMap,
	machineDiscontinuation: machineDiscontinuation,
	notifications: notifications,
	results: results,
	scrollToTop: scrollToTop,
	slider: slider,
	sorting: sorting,
	userAccount: userAccount,
	widget: widget,
	widgetRegistry: widgetRegistry
};

export { app, contentLoadingError, dashboard, translation as default, filter, locationMap, machineDiscontinuation, notifications, results, scrollToTop, slider, sorting, userAccount, widget, widgetRegistry };
